import './header.scss';

import { Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { LeftOutlined, MenuOutlined } from '@/media/antd-icons';
import useGoBack from '@/shared/hooks/useGoBack';
import { useAppSelector } from '@/store';

import ProfileMenu from '../../entities/profile-menu';
import useNavItems from '../../hooks/useNavItems';
import BrandLogo from '../../ui/brand-logo';
import HeaderMenu from '../../ui/header-menu';

interface IProps {
  onOpenNav: () => void;
}

/**
 * Шапка кабинета. Широкий экран: логотип и разделы. Средний: бургер с разделами
 * в drawer, заголовок экрана и «назад». Узкий: бургер переезжает в таб-бар.
 * Справа всегда профиль: в его меню язык, тема и выход.
 */
const Header: React.FC<IProps> = ({ onOpenNav }) => {
  const { t } = useTranslation();
  const goBack = useGoBack();
  const { title, back } = useAppSelector((state) => state.app.headerConfig);
  const { items, activeCode } = useNavItems();

  return (
    <header className="header">
      <div className="header__container">
        <Button
          size="large"
          color="primary"
          variant="outlined"
          className="header__burger"
          icon={<MenuOutlined />}
          aria-label={t('layout.nav.open')}
          onClick={onOpenNav}
        />

        <div className="header__logo">
          <BrandLogo />
        </div>

        <div className="header__screen">
          {back && (
            <Button
              type="text"
              icon={<LeftOutlined />}
              aria-label={t('layout.backTo', { label: back.label })}
              onClick={() => goBack(back.to)}
            />
          )}
          <div className="header__screen-text">
            {title && <h1 className="header__title">{title}</h1>}
            {back && <p className="header__subtitle">{back.label}</p>}
          </div>
        </div>

        <div className="header__menu">
          <HeaderMenu items={items} activeCode={activeCode} />
        </div>

        <div className="header__actions">
          <ProfileMenu />
        </div>
      </div>
    </header>
  );
};

export default Header;
